export const environment = {
  domain: 'auc.digital',
  production: false,
  stand: '| STAGING',
  siteUrl: 'https://auc.digital/',
  profileUrl: 'https://auc.digital/profile',
  apolloClientsConfig: [
    {
      clientName: 'auth',
      endpoint: 'https://auc.digital/graphql/auth',
      fetchPolicy: 'network-only',
    },
    {
      clientName: 'core',
      endpoint: 'https://auc.digital/graphql/core',
      fetchPolicy: 'network-only',
    },
    {
      clientName: 'lots',
      endpoint: 'https://auc.digital/graphql/lots',
      fetchPolicy: 'network-only',
    },
  ],
};
